module.exports = __webpack_public_path__ + "img/One_hundred_&_twenty.a539c150.svg";